export default function StreamOutputDescUdpMulticast({ output }) {
  return (<>
    UDP {output.group}:{output.port} @ {output.iface}
  </>);
}
